import type { VybeTraderClient } from "../connection/client/VybeTraderClient";
import { formatTradingAccountKey } from "../chart/utils/accountHelpers";
import { useMailboxStore } from "./stores/useMailboxStore";

export async function prepareAndSyncMailbox(
  client: VybeTraderClient,
  account: {
    credentials: { login: string };
    lastConnectedHost?: string;
    lastConnectedPort?: number;
  }
): Promise<void> {
  const accountKey = formatTradingAccountKey(account);
  if (!accountKey) return;

  const store = useMailboxStore.getState();
  store.setActiveAccount(accountKey);

  const request = store.buildSyncRequest();
  await client.syncMailbox(request);
}
